import { render, staticRenderFns } from "./FosterFamilyAssignmentEditor.vue?vue&type=template&id=4f8b71dc&scoped=true&"
import script from "./FosterFamilyAssignmentEditor.vue?vue&type=script&lang=js&"
export * from "./FosterFamilyAssignmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./FosterFamilyAssignmentEditor.vue?vue&type=style&index=0&id=4f8b71dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b71dc",
  null
  
)

export default component.exports